var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 39.5899C45.7167 39.5899 47.645 37.6399 47.645 35.2566L47.6667 13.5899C47.6667 11.2066 45.7167 9.25659 43.3333 9.25659H8.66667C6.28333 9.25659 4.33333 11.2066 4.33333 13.5899V35.2566C4.33333 37.6399 6.28333 39.5899 8.66667 39.5899H0V43.9233H52V39.5899H43.3333ZM8.66667 13.5899H43.3333V35.2566H8.66667V13.5899Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.baa0c677b7337a46840aa893aebcdf76.svg";
export { ForwardRef as ReactComponent };